<!--
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-10-08 15:19:33
 * @LastEditors: wuzijia wuzijia1230@qq.com
 * @LastEditTime: 2023-10-14 20:54:34
 * @FilePath: \youxi\src\views\XXHavingYou\RankList.vue
 * @Description  : Description
-->
<template>
  <div
    class="rank-list "
    :class="[type === 1 ? 'rank-list-reco-bg' : 'rank-list-trade-bg']"
  >
    <div class="rank-list-head">
      <img class="rank-list-head-bg" src="./img/rank-head-bg.png" />
      <div class="rank-list-head-first">
        <div class="first-avatar">
          <div class="first-avatar-img">
            <img :src="rankFirst.user.touxiang" />
            <div class="filter"></div>
          </div>
          <img class="first-avatar-over" src="./img/rank1.png" />
        </div>
        <div class="first-detail">
          <div class="first-detail-name text-ellipsis">
            {{ formatName(rankFirst.user.nickname) }}
          </div>
          <div class="first-detail-sum" v-if="rankFirst.num">
            {{
              (type === 1 ? "邀请数" : "交易额") +
                rankFirst.num +
                (type === 1 ? "人" : "元")
            }}
          </div>
        </div>
      </div>
      <div class="rank-list-head-second">
        <div class="second-avatar">
          <div class="second-avatar-img">
            <img :src="rankSecond.user.touxiang" />
            <div class="filter"></div>
          </div>
          <img class="second-avatar-over" src="./img/rank2.png" />
        </div>
        <div class="second-detail">
          <div class="second-detail-name text-ellipsis">
            {{ formatName(rankSecond.user.nickname) }}
          </div>
          <div class="second-detail-sum" v-if="rankSecond.num">
            {{
              (type === 1 ? "邀请数" : "交易额") +
                rankSecond.num +
                (type === 1 ? "人" : "元")
            }}
          </div>
        </div>
      </div>
      <div class="rank-list-head-third">
        <div class="third-avatar">
          <div class="third-avatar-img">
            <img :src="rankThird.user.touxiang" />
            <div class="filter"></div>
          </div>
          <img class="third-avatar-over" src="./img/rank3.png" />
        </div>
        <div class="third-detail">
          <div class="third-detail-name text-ellipsis">
            {{ formatName(rankThird.user.nickname) }}
          </div>
          <div class="third-detail-sum" v-if="rankThird.num">
            {{
              (type === 1 ? "邀请数" : "交易额") +
                rankThird.num +
                (type === 1 ? "人" : "元")
            }}
          </div>
        </div>
      </div>
    </div>
    <template v-if="rankList.length">
      <div class="rank-list-item" v-for="(v, k) in rankList" :key="k">
        <div class="rank-list-item-rank">
          {{ k + 4 }}
        </div>
        <div class="rank-list-item-avatar">
          <img :src="v.user.touxiang" />
          <div class="filter"></div>
        </div>
        <div class="rank-list-item-name">{{ formatName(v.user.nickname) }}</div>
        <div class="rank-list-item-sum">
          {{ v.num + (type === 1 ? "人" : "元") }}
        </div>
      </div>
    </template>
    <div class="rank-list-mine" v-if="myRank">
      <div class="rank-list-mine-rank">
        {{ myRank.rank }}
      </div>
      <img class="rank-list-mine-avatar" :src="userInfo.touxiang" />
      <div class="rank-list-mine-name">{{ formatName(userInfo.nickname) }}</div>
      <div class="rank-list-mine-sum">{{ upText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 1
    },
    list: {
      type: Array,
      default: () => Array(7).fill(1)
    },
    userInfo: {
      type: Object,
      default: () => {}
    },
    myRank: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    rankList() {
      return this.list.slice(3, 10) || [];
    },
    rankFirst() {
      return (
        this.list?.[0] || {
          user: {}
        }
      );
    },
    rankSecond() {
      return (
        this.list?.[1] || {
          user: {}
        }
      );
    },
    rankThird() {
      return (
        this.list?.[2] || {
          user: {}
        }
      );
    },
    upText() {
      if ((this.myRank.rank === '未上榜' || this.myRank.rank > 10) && this.list?.length < 10) {
        return "距离上榜还差1" + (this.type === 1 ? "人" : "元");
      }
      if (this.myRank.rank === 1) {
        return "恭喜您获得第一名";
      }
      if (this.myRank.rank <= 10) {
        const sum = this.list[this.myRank.rank - 2].num - this.myRank.num;
        return "距离上一名还差" + (sum || 1) + (this.type === 1 ? "人" : "元");
      }
      const sum = this.list[this.list.length - 1].num - this.myRank.num;
      return "距离上榜还差" + (sum || 1) + (this.type === 1 ? "人" : "元");
    }
  },
  data() {
    return {
      myInfo: {}
    };
  },
  methods: {
    formatName(name = "") {
      if (!name) {
        return name;
      }
      if (name.length > 8) {
        return (
          name.substring(0, 3) +
          "****" +
          name.substring(name.length - 3, name.length)
        );
      }
      return name;
    }
  }
};
</script>

<style lang="less">
.rank-list {
  position: relative;

  box-sizing: border-box;
  padding-top: 78px;
  width: 618px;
  height: 1085px;
  border-radius: 4px;

  .text-ellipsis {
    overflow: hidden;

    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &-head {
    position: relative;

    width: 100%;
    height: 230px;

    &-bg {
      position: absolute;
      bottom: 0;
      left: 35px;
    }

    &-first,
    &-second,
    &-third {
      position: absolute;
      top: 0;
    }

    &-first {
      left: 190px;

      width: 232px;
      height: 100%;

      .first-avatar {
        position: relative;

        margin-left: 48px;
        width: 138px;
        height: 138px;

        &-over {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          width: 138px;
          height: 138px;
        }

        &-img {
          position: relative;
          top: 8px;
          left: 21px;

          border-radius: 50%;
          width: 94px;
          height: 94px;
          img {
            border-radius: 50%;
            width: 94px;
            height: 94px;
          }
          .filter {
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 50%;
            width: 94px;
            height: 94px;
            backdrop-filter: blur(3px);
            z-index: 1;
          }
        }
      }

      .first-detail {
        display: flex;

        margin-top: 15px;

        font-size: 22px;
        text-align: center;

        color: #666;

        flex-direction: column;

        &-sum {
          margin-top: 5px;

          font-size: 20px;

          color: var(--gold, #C9974D);
        }
      }
    }

    &-second {
      left: 35px;

      width: 165px;
      height: 100%;

      .second-avatar {
        position: relative;

        width: 113px;
        height: 120px;

        &-over {
          position: absolute;
          top: 40px;
          left: 30px;
          z-index: 2;
          width: 113px;
          height: 120px;
        }

        &-img {
          position: relative;
          top: 40px;
          left: 44px;

          border-radius: 50%;
          width: 84px;
          height: 84px;
          img {
            border-radius: 50%;
            width: 84px;
            height: 84px;
          }
          .filter {
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 50%;
            width: 84px;
            height: 84px;
            backdrop-filter: blur(3px);
            z-index: 1;
          }
        }
      }

      .second-detail {
        display: flex;

        margin-top: 42px;

        font-size: 22px;
        text-align: center;

        color: #666;

        flex-direction: column;

        &-sum {
          font-size: 20px;

          color: var(--gold, #C9974D);
        }
      }
    }

    &-third {
      right: 40px;

      width: 168px;
      height: 100%;

      .third-avatar {
        position: relative;

        width: 93px;
        height: 116px;

        &-over {
          position: absolute;
          top: 48px;
          left: 40px;

          width: 93px;
          height: 116px;
        }

        &-img {
          position: relative;
          top: 50px;
          left: 44px;

          border-radius: 50%;
          width: 84px;
          height: 84px;
          img {
            border-radius: 50%;
            width: 84px;
            height: 84px;
          }
          .filter {
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 50%;
            width: 84px;
            height: 84px;
            backdrop-filter: blur(3px);
            z-index: 1;
          }
        }
      }

      .third-detail {
        display: flex;

        margin-top: 50px;

        font-size: 22px;
        text-align: center;

        color: #666;

        flex-direction: column;

        &-sum {
          font-size: 20px;

          color: var(--gold, #C9974D);
        }
      }
    }
  }

  &-reco-bg {
    background: url("./img/rank-reco-bg.png");
  }

  &-trade-bg {
    background: url("./img/rank-trade-bg.png");
  }

  &-item {
    display: flex;

    margin: 20px 0 0 40px;
    padding: 0 60px 0 20px;
    width: 539px;
    height: 77px;

    font-size: 22px;

    color: #fff;
    background: url("./img/rank-list-bar.png") no-repeat;

    align-items: center;
    position: relative;

    &-rank {
      width: 30px;
      height: 34px;

      font-size: 20px;
      line-height: 34px;
      text-align: center;

      color: #fff;
      background: url("./img/rank-list-bar-icon.png");
      background-size: 100% 100%;
    }

    &-avatar {
      position: relative;
      margin: 0 10px 0 20px;
      img {
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 50%;
        width: 57px;
        height: 57px;
      }
      .filter {
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 50%;
        width: 57px;
        height: 57px;
        border-radius: 4px;
        backdrop-filter: blur(3px);
        z-index: 1;
      }
    }

    &-name {
      flex: 1;
    }

    &-sum {
      font-size: 20px;
    }
  }

  &-mine {
    display: flex;

    position: absolute;
    bottom: 0;
    left: 0;

    border-radius: 0 0 4px 4px;
    padding: 0 36px 0 32px;
    width: 619px;
    height: 91px;

    font-size: 20px;

    color: #fff;
    background: #F0EDE8;
    // justify-content: space-between;

    align-items: center;
    &-avatar {
      margin: 0 18px 0 15px;
      border-radius: 50%;
      width: 60px;
      height: 60px;
    }

    &-name {
      font-size: 22px;

      flex: 1;
    }

    &-sum {
      margin-left: 10px;
    }
  }
}
</style>
